import { requestBuilder } from '../../http/RequestBuilder';
import type { User } from '../../user/types/User';

const useGetJointAccountHolders = requestBuilder.query<
    User[],
    { userId: string }
>({
    endpoint: ({ userId }) =>
        `/api/bank-accounts/user/${userId}/joint-account-holders`,
    queryKey: ({ userId }) => `getJointAccountHolders/${userId}`,
});

export default useGetJointAccountHolders;
